import { Component, inject } from "@angular/core";
import { MatDialogRef, MatDialogContent } from "@angular/material/dialog";
import { RouteService } from "@app/services/http/route.service";
import { ZoneLookupMessage } from "@app/models/dto/zone-lookup-message";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { TranslatePipe } from "@ngx-translate/core";
import { DialogHeaderComponent } from "@app/view/shared/dialog-header/dialog-header.component";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";

export interface ZonePostcodeLookupResult {
  showOnMap: boolean;
  postcode: string;
  longitude: number | null;
  latitude: number | null;
}

@Component({
  selector: "app-zone-postcode-lookup",
  templateUrl: "./zone-postcode-lookup.component.html",
  styleUrls: ["./zone-postcode-lookup.component.scss"],
  imports: [
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    MatProgressSpinner,
    MatButton,
    MatIcon,
    TranslatePipe,
    DialogHeaderComponent
  ]
})
export class ZonePostcodeLookupComponent {
  protected routeService = inject(RouteService);
  protected serviceErrorHandler = inject(ServiceErrorHandlerService);
  dialogRef = inject<MatDialogRef<ZonePostcodeLookupComponent>>(MatDialogRef);

  postcodeControl = new FormControl("");
  searching = false;
  error = false;
  result: ZoneLookupMessage | null = null;

  async lookup() {
    if (this.searching) {
      return;
    }
    const query = (this.postcodeControl.value || "").trim();
    if (!query) {
      this.result = null;
      this.error = false;
      return;
    }
    this.searching = true;
    this.error = false;
    this.result = null;
    try {
      this.result = await this.routeService.lookupZonesByPostcode(query);
    } catch (e) {
      this.error = true;
      this.serviceErrorHandler.handleError(e);
    } finally {
      this.searching = false;
    }
  }

  showOnMap() {
    if (!this.result || !this.result.found) {
      return;
    }
    const payload: ZonePostcodeLookupResult = {
      showOnMap: true,
      postcode: this.result.postcode,
      longitude: this.result.longitude,
      latitude: this.result.latitude
    };
    this.dialogRef.close(payload);
  }

  onClose() {
    this.dialogRef.close();
  }
}
